import React from 'react'

const Social = () => {
  return (
    <div className="home_social">
        <a href="https://www.linkedin.com/in/rohith-matham/" className="home_social-icon" >
            <i class="uil uil-linkedin"> </i>
        </a>
        <a href="https://github.com/Rohithmatham12" className="home_social-icon" >
        <i class="uil uil-github-alt"> </i>
        </a>
        <a href="mailto:rohithmatham@gmail.com" className="home_social-icon" >
        <i className ="uil uil-envelope"> </i>
        </a>
    </div>
  )
}

export default Social
